import React from "react";
import { Modal, Table } from "react-bootstrap";
import { tableStyles } from "Constants/Style";
import CancelBackButton from "components/Buttons/CancelBackButton";

interface Bag {
  bag_no: string;
  total_quantity: number;
  issued_quantity: number;
  inventory_item_id?: string;
}

interface ViewBagsModalStockTransferProps {
  show: boolean;
  handleClose: () => void;
  bags: Bag[];
  itemName?: string;
}

const ViewBagsModalStockTransfer: React.FC<ViewBagsModalStockTransferProps> = ({
  show,
  handleClose,
  bags = [],
  itemName,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header className="border-0">
        <Modal.Title className="fw-bold">
          {itemName ? `Bag Details - ${itemName}` : "Bag Details"}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        />
      </Modal.Header>
      <hr />
      <Modal.Body>
        {bags.length === 0 ? (
          <div className="text-center py-4 text-muted">
            No bags available for this item.
          </div>
        ) : (
          <Table responsive className="align-middle text-center">
            <thead className="table-light border-bottom">
              <tr>
                <th style={{ ...tableStyles.headerAlt, minWidth: 70 }} className="py-3 px-3">
                  Sr No.
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 200 }} className="py-3 px-3">
                  Bag No.
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 150 }} className="py-3 px-3">
                  Issued Quantity
                </th>
              </tr>
            </thead>
            <tbody>
              {bags.map((bag, idx) => (
                <tr key={idx} className="border-bottom">
                  <td style={tableStyles.cell} className="py-2 px-3">
                    {idx + 1}
                  </td>
                  <td style={tableStyles.cell} className="py-2 px-3">
                    {bag.bag_no || "-"}
                  </td>
                  <td style={tableStyles.cell} className="py-2 px-3">
                    {bag.issued_quantity || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <CancelBackButton
          label="Close"
          onClick={handleClose}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ViewBagsModalStockTransfer;

